import { formatCurrency, formatDate, getAcronym, getRentPaymentStatusProps } from "./helpers";
import { longMonthDateFormat, shortDateTimeFormat } from "./constants";

//Helper function to transform activities
export const getTransformedActivities = (response = {}) => {
  const updatedResponse = {
    ...response,
    data: {
      ...(response?.data ?? {}),
      data: { ...(response?.data?.data ?? {}), activities: [...(response?.data?.data?.activities ?? [])].reverse() },
    },
  };

  return updatedResponse;
};

// Helper function to get the activity date or status
export const getActivityDateOrStatus = (activity) => {
  const { status, datetime } = activity;
  const trimmedStatus = status.trim();

  if (!trimmedStatus || trimmedStatus === "PendingReview") {
    return trimmedStatus === "PendingReview" ? "Pending" : formatDate(datetime, longMonthDateFormat);
  }

  return trimmedStatus;
};

// Helper function to transform payroll accounts
export const getTransformedPayrollAccounts = (accounts = []) => {
  return accounts?.map((account) => {
    let allocationAmount = null;
    let remainderAmount = null;

    account?.allocations
      ?.filter((allocation) => allocation.allocationType === "remainder")
      ?.forEach((allocation) => {
        if (!!allocation?.amount) {
          remainderAmount = (remainderAmount ?? 0) + allocation?.amount;
        }
      });

    account?.allocations
      ?.filter((allocation) => allocation.allocationType !== "remainder")
      ?.forEach((allocation) => {
        if (!!allocation?.amount) {
          allocationAmount = (allocationAmount ?? 0) + allocation?.amount;
        }
      });

    if (!!allocationAmount) {
      allocationAmount = allocationAmount / 100;
    }

    if (!!remainderAmount) {
      remainderAmount = remainderAmount / 100;
    }

    let amountLabel = "";
    let updatedOnLabel = null;
    let connectionStatusLabel = "";

    if (remainderAmount == null && allocationAmount != null) {
      let amount = formatCurrency(allocationAmount)?.replace(".00", "");
      switch (account.connection_status) {
        case "success":
          amountLabel = amount + " every paycheck";
          break;
        case "pending":
          amountLabel = amount + " per paycheck";
          break;
        case "disconnected":
          amountLabel = amount + " per paycheck";
          break;
        default:
          amountLabel = "";
      }
    } else if (remainderAmount == null && allocationAmount == null) {
      amountLabel = "Entire paycheck";
    } else if (remainderAmount != null && allocationAmount == null) {
      let amount = formatCurrency(remainderAmount)?.replace(".00", "");

      amountLabel = `Entire paycheck minus ${amount} to other accounts`;
    }

    switch (account.connection_status) {
      case "success":
        updatedOnLabel = `Last update: ${formatDate(account.updated_at, shortDateTimeFormat)}`;
        connectionStatusLabel = "Connected";
        break;
      case "pending":
        updatedOnLabel = null;
        connectionStatusLabel = "Pending";
        break;
      case "disconnected":
        updatedOnLabel = "Last update: N/A. Please reconnect";
        connectionStatusLabel = "Please Reconnect";
        break;
      default:
        updatedOnLabel = null;
        connectionStatusLabel = "";
    }

    return { ...account, amountLabel, updatedOnLabel, connectionStatusLabel };
  });
};

export const getTransformedRentPaymentTransaction = (transactions) =>
  transactions?.map((transaction) => ({
    ...transaction,
    ...getRentPaymentStatusProps(transaction.status),
    total: (transaction?.amount ?? 0) + (transaction?.fee ?? 0),
    payeeAcronym: getAcronym(transaction.payee),
  }));

export const getStakeDebitAPIObject = (stakeDebitStatus) => {
  return { data: { status: stakeDebitStatus } };
};
